var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "title_box" }, [
    _c("div", { staticClass: "mask" }),
    _vm._v(" "),
    _c("div", { staticClass: "title-wrap" }, [
      _c("div", { staticClass: "title_name" }, [
        _c("label", [_vm._v(_vm._s(_vm.promp.title))]),
        _vm._v(" "),
        _c("span", { on: { click: _vm.closeFrame } }, [
          _c("i", { staticClass: "icon-close" })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "text" }, [
        _c("span", { staticClass: "starRed" }, [_vm._v("*")]),
        _vm._v(" "),
        _c("label", { attrs: { for: "info" } }, [
          _vm._v(_vm._s(_vm.promp.name) + ":")
        ]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.promp.inputCent,
              expression: "promp.inputCent"
            }
          ],
          attrs: {
            type: "text",
            id: "info",
            placeholder: _vm.promp.placeholder,
            maxlength: _vm.promp.maxNum
          },
          domProps: { value: _vm.promp.inputCent },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.promp, "inputCent", $event.target.value)
            }
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "btn_title" }, [
        _c("div", { staticClass: "btn_left btn", on: { click: _vm.cancel } }, [
          _vm._v(_vm._s(_vm.btnTextLeft))
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "btn_right btn", on: { click: _vm.confirm } },
          [_vm._v(_vm._s(_vm.btnTextRight))]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }